const initials = "checkerAnswerList/";
export const UPDATE_CHECKER_ANSWER_LIST = `${initials}UPDATE_CHECKER_ANSWER_LIST`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;
export const UPDATE_CHECKER_ANSWER_INFO = `${initials}UPDATE_CHECKER_ANSWER_INFO`;
